/**
 * Frontend view script for the Social Share block.
 *
 * Runs once the DOM is ready and replaces the placeholder "#" href on each
 * sharing anchor with the correct share URL built from the current page URL.
 *
 * This file is declared as `viewScript` in block.json so WordPress only
 * enqueues it on pages that actually contain the Social Share block.
 */

document.addEventListener( 'DOMContentLoaded', function () {
	const pageUrl = encodeURIComponent( window.location.href );

	document
		.querySelectorAll( '.wp-block-tbf-blocks-social-share' )
		.forEach( function ( block ) {
			const twitter = block.querySelector(
				'.social-share__link--twitter'
			);
			const facebook = block.querySelector(
				'.social-share__link--facebook'
			);
			const email = block.querySelector( '.social-share__link--email' );

			if ( twitter ) {
				twitter.href =
					'https://twitter.com/intent/tweet?url=' + pageUrl;
			}

			if ( facebook ) {
				facebook.href =
					'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
			}

			if ( email ) {
				email.href = 'mailto:?body=' + pageUrl;
			}
		} );
} );
